import styled from "styled-components";

export const TableContainer = styled.div`
  border: 1px solid var(--Neutral-800, #43424a);
  border-radius: 12px;
  overflow: hidden;
  .ant-table {
    background-color: transparent;
    border-radius: 12px !important;
  }
  .ant-pagination-item-ellipsis {
    color: #fff !important;
  }
  .ant-table-placeholder {
    background: transparent !important;
    .ant-table-cell {
      background: transparent !important;
    }
  }
  .ant-empty-normal .ant-empty-description {
    color: #fff;
  }
  .ant-table-container {
    .ant-table-cell {
      background: #141518;
      color: #fff;
      border: 0;
      vertical-align: middle;
      padding: 16px 10px;
      font-size: 14px;
      text-align: center;
      color: var(--Neutral-100, #eeeef0);
      text-align: center;
      font-family: Syne;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 142.857% */
      &::before {
        content: none !important;
      }
    }
    .ant-table-thead {
      .ant-table-cell {
        background: #141518;
        &:first-child {
          border-top-left-radius: 12px;
        }
        &:last-child {
          border-top-right-radius: 12px;
        }
      }
    }
    .ant-table-cell-row-hover {
      background-color: #252831 !important;
      cursor: pointer;
    }
  }
  .ant-table-tbody {
    .ant-table-cell {
      background-color: #0e0e0e;
      padding-top: 22px;
      padding-bottom: 22px;
    }
    .ant-table-row {
      &:last-child {
        .ant-table-cell {
          &:first-child {
            border-bottom-left-radius: 12px;
          }
          &:last-child {
            border-bottom-right-radius: 12px;
          }
        }
      }
    }
  }
  .ant-pagination {
    margin-bottom: 0 !important;
    svg {
      path {
        fill: #fff;
      }
    }
    .ant-pagination-item {
      border-radius: 8px;
      background: #1b1c20;
      border: none;
      transition: all 0.25s ease;
      &:hover {
        background-color: #e84142;
      }
      a {
        color: #fff;
      }
      &.ant-pagination-item-active {
        background-color: #e84142;
      }
    }
  }
  .tag {
    border-radius: 4px;
    background: #28272c;
    padding: 4px 16px;
    display: inline-block;
    min-width: 85px;
    &.is-success {
      background: rgba(15, 245, 134, 0.1);
      color: var(--Spring-Green-500, #0ff586);
    }
    &.is-refund {
      background: linear-gradient(
        90deg,
        rgba(255, 53, 86, 0.1) 0%,
        rgba(255, 219, 134, 0.1) 100%
      );
      span {
        background: linear-gradient(
          90deg,
          #ff4671 0%,
          #ff8396 52.71%,
          #ffdf95 105.41%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    &.light {
      background: rgba(184, 184, 193, 0.4);
      color: var(--Neutral-400, #92929e);
      &.is-success {
        background: rgba(15, 245, 134, 0.1);
        color: var(--Spring-Green-800, #0a7140);
      }
      &.is-refund {
        background: linear-gradient(
          90deg,
          rgba(255, 53, 86, 0.2) 0%,
          rgba(255, 219, 134, 0.2) 100%
        );
      }
    }
  }
  &.light {
    border: solid 1px rgb(184, 184, 193);
    .ant-table-container {
      .ant-table-thead {
        .ant-table-cell {
          background: #f6f6f6;
          color: var(--Neutral-700, #4d4d57);
        }
      }
      .ant-table-tbody {
        .ant-table-cell {
          background: #fff;
          color: var(--Neutral-950, #141518);
        }
      }
      .ant-table-cell {
        font-weight: 500;
      }
      .ant-table-cell-row-hover {
        background-color: #f3f2f2 !important;
      }
    }
    .ant-pagination {
      & > li {
        &.ant-pagination-item {
          background-color: #43424a;
          &:hover {
            background-color: #d7d2d2;
          }
          &.ant-pagination-item-active {
            background-color: #e84142;
          }
        }
        .ant-pagination-item-ellipsis {
          color: #6d6d6d !important;
        }
        .ant-pagination-item-link {
          svg {
            path {
              fill: #6d6d6d;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1440px) {
    .ant-table-content {
      overflow-x: auto;
    }
  }
  @media screen and (max-width: 767px) {
    thead {
      display: none;
    }
    .ant-table-cell {
      padding: 10px !important;
    }
    .ant-table-row {
      display: flex;
      flex-direction: column;
      width: 100%;
      border-radius: 10px;
      overflow: hidden;
      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }
    .ant-pagination {
      flex-wrap: unset;
      justify-content: center;
    }
    .ant-table-thead {
      .ant-table-cell {
        &:first-child {
          border-top-left-radius: 0;
        }
        &:last-child {
          border-top-right-radius: 0;
        }
      }
    }
    .ant-table-tbody {
      .ant-table-row {
        &:last-child {
          .ant-table-cell {
            &:first-child {
              border-bottom-left-radius: 0;
            }
            &:last-child {
              border-bottom-right-radius: 0;
            }
          }
        }
      }
    }
  }
`;
